import { Center, Stack, Text } from '@mantine/core';
import { useState } from 'react';
import { Client } from 'src/users';
import { useClientsContext } from 'src/clients/context/ClientsContext';
import { Button } from 'src/design-system/Button';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { formatName, NameFormat } from 'src/utils/nameFormatting';
import { LinkToExistingFamilyModal } from './LinkToExistingFamilyModal';

type Props = {
  client: Client;
};

export function FamilyEmptyState({ client }: Props) {
  const { startFamilyCreation } = useClientsContext();
  const [linkModalOpen, setLinkModalOpen] = useState(false);

  const fullName = formatName(client.firstName, client.lastName, NameFormat.NATURAL);

  return (
    <Center py="xxl">
      <Stack align="center" gap={0}>
        <Text size="displayXs" fw={FONT_WEIGHTS.medium} c="black" ta="center">
          Create family for {fullName}
        </Text>
        <Text size="xs" fw={FONT_WEIGHTS.medium} c="gray.8" ta="center" maw={416} mt={8}>
          Link {client.firstName} with other family members to manage finances together — combine
          assets, generate joint reports, and see the full picture across everyone.
        </Text>
        <Button
          variant="primary"
          size="lg"
          w={197}
          py={12}
          mt={24}
          onClick={() => setLinkModalOpen(true)}
        >
          Link to existing family
        </Button>
        <Button
          variant="secondary"
          size="lg"
          w={197}
          px={30}
          py={12}
          mt={12}
          onClick={startFamilyCreation}
        >
          Create new family
        </Button>
      </Stack>
      <LinkToExistingFamilyModal
        opened={linkModalOpen}
        onClose={() => setLinkModalOpen(false)}
        client={client}
      />
    </Center>
  );
}
